import React from 'react';
import { AppTextLabel } from "@@commons";
import { UrlInputRaw } from "./urlInputRaw";
import { EntityValidationError } from "@inwink/entityform";
import { DropdownEditor, IDropdownEditorItem } from '../dropdowneditor';

interface IUrlInputRawWrapper {
    fieldName?: string;
    onChange: (fieldKey: string, url: any, target?: string) => void;
    onValidChange?: (isValid: boolean) => void;
    validations?: EntityValidationError[];
    addValidationError?: (fieldKey: string, err: EntityValidationError) => Promise<any>;
    removeValidationError?: (fieldKey: string, err: EntityValidationError, options?: any) => Promise<any>;
    checkValidations?: () => void;
    entityName?: string;
    value: string;
    target?: string;
    showLabel?: boolean;
    readOnly?: boolean;
    instanceId?: string;
    enableTargetOption?: boolean;
}

export const onValidationUrlChange = (
    isValid: boolean,
    fieldName,
    validations,
    addValidationError,
    removeValidationError,
    checkValidations
) => {
    const fieldValidationError = { field: fieldName || 'link', error: 'invalidurl' };

    const alreadyErrorsValidation = validations?.filter((validation) => {
        return validation.field === fieldValidationError?.field && validation.error === fieldValidationError?.error;
    });

    if (!isValid && !alreadyErrorsValidation?.length) {
        if (addValidationError) {
            addValidationError(fieldValidationError?.field, fieldValidationError).then(() => {
                if (checkValidations)
                    checkValidations();
            });
        }
    } else if (isValid && alreadyErrorsValidation?.length) {
        if (removeValidationError) {
            removeValidationError(fieldValidationError?.field, fieldValidationError, { findIndexByObject: true }).then(() => {
                if (checkValidations)
                    checkValidations();
            });
        }
    }
};

export const UrlInputRawWrapper = ({
    fieldName,
    onChange,
    onValidChange,
    validations,
    addValidationError,
    removeValidationError,
    checkValidations,
    entityName,
    value,
    target,
    showLabel,
    readOnly,
    instanceId,
    enableTargetOption
}: IUrlInputRawWrapper) => {
    const onUrlChange = (url: string, t?: string) => onChange(fieldName, url, t);

    const onValidUrlChange = (isValid: boolean) => {
        // custom valid :
        if (onValidChange) { return onValidChange(isValid); }

        // generic valid:
        onValidationUrlChange(isValid, fieldName, validations, addValidationError, removeValidationError, checkValidations);
    };

    const targetValues: IDropdownEditorItem[] = [
        { key: "_blank", label: "urlinput.target.blank" },
        { key: "_self", label: "urlinput.target.self" }
    ];
    enableTargetOption = false;

    return (
        <div>
            {showLabel && <AppTextLabel component="label" i18n={`${entityName?.toLowerCase()}.${fieldName?.toLowerCase()}`} />}

            <UrlInputRaw
                onUrlChange={onUrlChange}
                onValidUrlChange={onValidUrlChange}
                needCheckUrl
                value={value}
                readOnly={readOnly}
                instanceId={instanceId}
            />
            {/* <select onChange={()} value={target}>
                <AppTextLabel i18n='urlinput.target.blank' component='option' value='_blank' />
                <AppTextLabel i18n='urlinput.target.self' component='option' value='_self' />
            </select> */}
            {enableTargetOption ? <DropdownEditor
                selection={targetValues.filter(t => t.key == target)}
                allItems={targetValues}
                onChange={(t) => onUrlChange(value, t[0].key)}
                multiselect={false}
            /> : null}
        </div>
    );
};
